import { PayloadAction } from '@reduxjs/toolkit';
import { createGenericSlice, GenericState } from '../GenericSlice';

const initialState: GenericState<authState> = {
	isAuthenticated: false,
	data: {
		accessToken: '',
		refreshToken: '',
		user: {
			_id: null,
			name: null,
			email: null,
			createdAt: null,
			updatedAt: null,
		},
	},
	status: null,
	error: null,
};

const authSlice = createGenericSlice({
	name: 'auth',
	initialState,
	reducers: {
		logout: () => initialState,
		loginSuccess: (
			state: GenericState<authState>,
			action: PayloadAction<authState>
		) => {
			state.isAuthenticated = true;
			state.data = action.payload;
			state.status = 'finished';
			state.error = null;
		},
	},
});

export const {
	start: loginStart,
	loginSuccess,
	error: loginError,
	logout,
} = authSlice.actions;

export const authSelector = (state: IRootState) => state.auth;

export default authSlice.reducer;
